// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 894) return "digital-content.7033b2cc0635da381db2.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"17":"0f4a5885ad8387ed1b12","34":"d9a78e3a641942347195","366":"6f0ee1a86c40a668fdf0","439":"4f9efaedb1826c304771","524":"de0147d4dec85cdf450f","793":"1df5f5377e4fbddde2a3"}[chunkId] + ".css";
};